import * as api from "@/api/procedures";
import { ProcedureSearch } from "@/api/procedures";
import { useQuery } from "react-query";

export function useGetProcedures(filters: ProcedureSearch) {
  const queryKey = ["procedures", { filters }];
  return useQuery(queryKey, () => api.getProcedures(filters));
}
